<!--
  Onboarding wizard body. The parent (`<myp-community>`) owns the full-screen container
  (`<main basepage="primary" class="fullwidth-layout-container h-full">` + centered flex
  wrapper); this component renders the card contents that swap between steps.

  Three steps: `init` (shared) → `profile` (shared, skipped when not needed) →
  `community_specific` (per-community — branches on `communityStringId`).
-->

@if (setupStep == "init") {
  <div class="position-relative">
    <div>
      <div>
        <h1 class="t-50 bold brandfont-black" style="font-size: 40px">{{ "sphere.welcome.welcome_to" | translate }} {{ communityTitle || env.studioOnePlusBrandName }}</h1>
      </div>
    </div>
  </div>
  <div class="position-relative" style="z-index: 999">
    <div class="community-onboarding-box">
      <span>{{ "com.onboarding.com_lets_you" | translate }}</span>
      <div class="m-y-50">
        <span class="bold">{{ "com.onboarding.step1" | translate }}</span>
        <div [innerHTML]="'com.onboarding.to_interact' | translate | safe: 'html'"></div>
        <br />
        <small class="text-muted">{{ "com.onboarding.decide_hidden" | translate }}</small>
      </div>
      <button class="btn btn-primary m-t-10 d-inline-block" (click)="setProfile(true)">
        {{ "com.onboarding.turn_it_on" | translate }}
        <fa-icon class="btn-primary" icon="check"></fa-icon>
      </button>
      <br />
      <br />
      <button class="tiny-link black m-t-10 d-inline-block" (click)="setProfile(false)">
        {{ "com.onboarding.keep_me_hidden" | translate }}
        <fa-icon icon="times"></fa-icon>
      </button>
    </div>
  </div>
}

@if (setupStep == "profile") {
  <div class="community-onboarding-box">
    <h1 class="bold">{{ "com.onboarding.step2" | translate }}</h1>
    <div class="row">
      @if (!user.firstName) {
        <div class="form-group col-md-6">
          <small class="text-muted">{{ "profile.edit.first_name" | translate }}</small>
          <input type="text" class="form-control" name="firstName" id="firstName" [(ngModel)]="profile.firstName" [placeholder]="'profile.edit.enter_name' | translate" />
        </div>
      }
      @if (!user.lastName) {
        <div class="form-group col-md-6">
          <small class="text-muted">{{ "profile.edit.last_name" | translate }}</small>
          <input type="text" class="form-control" name="lastName" id="lastName" [(ngModel)]="profile.lastName" [placeholder]="'profile.edit.enter_last_name' | translate" />
        </div>
      }
      <div class="form-group col-md-12">
        <small class="text-muted">{{ "com.tagline" | translate }}</small>
        <input type="text" class="form-control" name="tagline" id="tagline" [(ngModel)]="profile.tagline" [placeholder]="'com.enter_tagline' | translate" />
        <small class="text-muted">{{ "com.tagline_description" | translate }}</small>
      </div>
      <div class="form-group col-md-12">
        <small class="text-muted">{{ "profile.edit.description" | translate }}</small>
        <textarea name="description" id="description" [(ngModel)]="profile.description" class="form-control">{{ user.description }}</textarea>
        <small class="text-muted">{{ "com.profile_description" | translate }}</small>
      </div>
    </div>
    <div class="m-t-30">
      <button class="btn btn-primary" (click)="updateProfile()">{{ "sphere.welcome.continue" | translate }}</button>
      <br />
      <br />
      <button class="small-btn" (click)="updateProfile()">{{ "com.onboarding.do_this_later" | translate }}</button>
    </div>
  </div>
}

@if (setupStep == "community_specific") {
  <!-- FSP: the historic 4-icon summary + skills-add + "Let's go". -->
  @if (communityStringId == "fender-studio-pro") {
    <div class="community-onboarding-box">
      <h1 class="brandfont-bold">{{ "com.onboarding.done" | translate }}</h1>
      <span class="text-muted">{{ "com.onboarding.heres_more" | translate }}</span>
      <ul class="row">
        <li class="m-y-20 col-md-6">
          <fa-icon icon="bullhorn" class="t-40 c-official-blue"></fa-icon>
          <fui-heading [text]="'com.posts' | translate" [level]="3" textAlign="center" fontSize="f7" extraClasses="brandfont-bold"></fui-heading>
          <span class="text-muted">{{ "com.onboarding.posts_desc" | translate }}</span>
        </li>
        <li class="m-y-20 col-md-6">
          <fa-icon icon="guitar" class="t-40 c-official-blue"></fa-icon>
          <fui-heading [text]="'com.skills_word' | translate" [level]="3" textAlign="center" fontSize="f7" extraClasses="brandfont-bold"></fui-heading>
          <span class="text-muted">{{ "com.onboarding.skills_desc" | translate }}</span>
        </li>
        <li class="m-y-20 col-md-6">
          <fa-icon icon="microphone" class="t-40 c-official-blue"></fa-icon>
          <fui-heading [text]="'com.showcases' | translate" [level]="3" textAlign="center" fontSize="f7" extraClasses="brandfont-bold"></fui-heading>
          <span class="text-muted">{{ "com.onboarding.showcases_desc" | translate }}</span>
        </li>
        <li class="m-y-20 col-md-6">
          <fa-icon icon="comments" class="t-40 c-official-blue"></fa-icon>
          <fui-heading [text]="'com.connections_messages' | translate" [level]="3" textAlign="center" fontSize="f7" extraClasses="brandfont-bold"></fui-heading>
          <span class="text-muted">{{ "com.onboarding.connections_desc" | translate }}</span>
        </li>
      </ul>
      @if (mySkills && mySkills.length) {
        <div class="text-left m-y-20">
          @for (skill of mySkills; track skill) {
            <div class="list-item hover dontgrow">
              <div class="list-item-container">
                <div class="main-data">
                  <span class="title">{{ "com.skills." + skill.string_id | translate }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      }
      <div>
        <button class="btn btn-outline-primary m-r-10" (click)="addSkill()">
          {{ (mySkills && mySkills.length ? "com.add_more_skills" : "com.add_skills") | translate }}
          <fa-icon icon="chevron-right"></fa-icon>
        </button>
        <button class="btn btn-primary" (click)="finish()">{{ "com.onboarding.lets_go" | translate }}</button>
      </div>
    </div>
  }

  <!-- Tone Master Pro: welcome + community intro + Discord-migration explanation + inline Connect Discord. -->
  @if (communityStringId == "tone-master-pro") {
    <div class="community-onboarding-box">
      <h1 class="brandfont-bold">Welcome to {{ communityTitle || "Tone Master Pro" }}</h1>
      <img
        src="https://www.fender.com/cdn-cgi/image/format=auto,resize=height=auto,width=1500/https://www.fmicassets.com/Damroot/eCommPNG/10010/2274900000_fen_acc_frt_1_nr.png"
        style="max-width: 340px; width: 100%"
      />
      <p class="m-y-15">
        The Tone Master Pro Community is where players and producers meet to get more out of their Tone Master Pro. Share the presets you've built, break down mixes with other creators, and find tone
        recipes for the songs and rigs you're chasing. Follow builders whose sound you love, ask for help dialing in a patch, and keep tabs on new firmware, models, and features as they land.
      </p>
      <!--
        Discord section is gated behind `env.features.discordLinking` — same flag the account
        page uses to hide/show the Connections tab. When off (non-Fender builds, or Fender
        builds where the integration is unavailable), the wizard shows only the community
        intro above and skips the migration copy + Discord control entirely.
      -->
      @if (env.features?.discordLinking) {
        <hr class="m-y-20" />
        <h3 class="brandfont-bold t-20 m-b-10">From Discord to MyFender</h3>
        <p class="m-y-15 t-14 text-muted">
          We've brought the Tone Master Pro community together on MyFender so conversations stay organized, discoverable, and tied to the gear you play. If you were an active member of the Tone Master
          Pro Discord server, connect your account below and we'll re-attribute your posts and history to your profile automatically.
        </p>
        <!--
          Embed the account-page Discord control directly rather than launching it in a modal —
          the modal round-trip was clunky and the OAuth redirect blows the modal away anyway. The
          `[compact]="true"` input suppresses the component's own "Connections" heading + intro
          copy since our wizard already introduces the section above.
        -->
        <div class="text-left">
          <myp-account-connections [compact]="true"></myp-account-connections>
        </div>
      }
      <div class="m-t-30">
        <button class="btn btn-primary" (click)="finish()">{{ "com.onboarding.lets_go" | translate }}</button>
      </div>
    </div>
  }
}
